export default "__VITE_ASSET__xYifXdVy__"